import {useQuery} from 'react-query';
import getStoreTypeList from '.';

const useGetStoreTypeList = ({onSuccess}: {onSuccess?: () => void}) => {
  const {data, isLoading} = useQuery(
    ['get-store-type-list'],
    getStoreTypeList,
    {
      onSuccess: () => {
        onSuccess && onSuccess();
      },
    },
  );

  return {data, isLoading};
};

export default useGetStoreTypeList;
